import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TblHeadCellDef, UiTblSubSOBrkPSLevel, UITblGroup, AggregateType } from '../../shared/ui-classes';
import { SubEqupUIPipePipe } from '../../filters/sub-equiplevpipe.pipe';
import { DataService } from '../../shared/dataservice.service';
import { SubSalesOrder, PartialDelivery, Equipment, BreakerPS, configDefs, FileElement, monthFilter, userFilterOption, columnFilter } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';


@Component({
  selector: 'app-mast-plan-v2',
  templateUrl: './mast-plan-v2.component.html',
  styleUrls: ['./mast-plan-v2.component.css']
})
export class MastPlanV2Component implements OnInit {

  filteredHeadRows: Array<TblHeadCellDef> = [];
  _filterPipe: SubEqupUIPipePipe = new SubEqupUIPipePipe();
  _breakerPSUIObjList: Array<UiTblSubSOBrkPSLevel>;
  _filteredSubSoUIObjList: Array<UiTblSubSOBrkPSLevel>;
  _rowSpanArr:any = {};
  search: string = '';
  isFullScreenTbl: boolean = false;

  isLoading:boolean = false;
  isRevMonthFilterSelected:boolean = false;
  isManfMonthFilterSelected:boolean = false;
  isManfStrategyFilterSelected:boolean = false;
  isUserSelectionFilterSelected:boolean = false;

  revMonthFilter:monthFilter;
  manfMonthFilter:monthFilter;
  manfStrategyIndex:number = 0;
  userSelectionType:userFilterOption = userFilterOption.All;
  userDeptIdSelected:string = "";
  userDeptSelToken:string = "0,0,0"; 

  // filteredSaleOrderCount:number = 0;
  // filteredSubOrderCount:number = 0;

  filteredCustList:Array<columnFilter> = [];
  filteredProjectNameList:Array<columnFilter> = [];
  filteredSONumList:Array<columnFilter> = [];

  constructor(private _dataService: DataService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this._dataService.currPageName = ' Summary of Engg. Input and Material Reciept';
    this.isLoading = true;
    this.cd.markForCheck();
    this._dataService.getDataDefinitions().subscribe(res => {
      this.loadData();
    });


    try{
      this.loadSettingsFromCookies();
    }catch(e){
      console.log(e);
    }
  }

  loadData(): void {
    this.isLoading = true;
    this._dataService.getAllSalesOrder().subscribe((saleOrders) => {
      let _tmpSubSoUIObjList: Array<UiTblSubSOBrkPSLevel> = [];

      let _tmpFirstSOObj: UiTblSubSOBrkPSLevel;
      let _tmpFirstSubSOObj: UiTblSubSOBrkPSLevel;
      let _tmpFirstEquipmentObj: UiTblSubSOBrkPSLevel;

      saleOrders.forEach((saleOrder) => {
        let isFirstRowInSO: boolean = true;

        saleOrder.subSalesOrder.forEach((subSO) => {

          let isFirstRowInSubOrder: boolean = true;

          subSO.pmTechSubSalesOrder.equipmentList.forEach((equipment) => {


            let isFirstRowInEquipment: boolean = true;

            if(this.isVSCQtyEnabled(subSO.pmTechSubSalesOrder.productVarient,equipment.equipmentType,equipment.breakerType) == false){
                equipment.breakerPSList.forEach((brkrPS) => {
            
                  let _tmpObj = new UiTblSubSOBrkPSLevel(subSO, equipment, brkrPS, isFirstRowInSO, isFirstRowInSubOrder,isFirstRowInEquipment);
                  _tmpObj.soId = saleOrder.salesOrderId;
                  _tmpSubSoUIObjList.push(_tmpObj);

                  if (isFirstRowInSO) {
                    _tmpFirstSOObj = _tmpObj;
                  }
                  if (isFirstRowInSubOrder) {
                    _tmpFirstSubSOObj = _tmpObj;
                  }
                  if (isFirstRowInEquipment) {
                    _tmpFirstEquipmentObj = _tmpObj;
                  }

                _tmpFirstSOObj.totalBreakerPsCountForSo++;
                _tmpFirstSubSOObj.totalBreakerPsCountForSubSo++;
                _tmpFirstEquipmentObj.totalBreakerPsCountForEquip++;
                

                isFirstRowInSubOrder = false;
                isFirstRowInSO = false;
                isFirstRowInEquipment = false;

                });
            }
            else{
                let _tmpObj = new UiTblSubSOBrkPSLevel(subSO, equipment, null, isFirstRowInSO, isFirstRowInSubOrder,isFirstRowInEquipment);
                _tmpSubSoUIObjList.push(_tmpObj);

                if (isFirstRowInSO) {
                  _tmpFirstSOObj = _tmpObj;
                }
                if (isFirstRowInSubOrder) {
                  _tmpFirstSubSOObj = _tmpObj;
                }
                if (isFirstRowInEquipment) {
                  _tmpFirstEquipmentObj = _tmpObj;
                }

              _tmpFirstSOObj.totalBreakerPsCountForSo++;
              _tmpFirstSubSOObj.totalBreakerPsCountForSubSo++;
              _tmpFirstEquipmentObj.totalBreakerPsCountForEquip++;

              isFirstRowInSubOrder = false;
              isFirstRowInSO = false;
              isFirstRowInEquipment = false;
          
            }
          
            
          });
        });
      })

      //init the required ui name
      _tmpSubSoUIObjList.forEach((_subsoUIObj) => {
        this.prepareSSOUIObjData(_subsoUIObj)
      });
      this._breakerPSUIObjList = _tmpSubSoUIObjList;

      this.filterRows();
      this.isLoading = false;
    });
  }
  isVSCQtyEnabled(_variantId: string, _equipTypeId : string, _brkrTypeID){
    if(this.isSpecifiedEquipType(_equipTypeId) == false) return false; 
    return this._dataService.isVSCQtyEnable(_variantId, _equipTypeId,_brkrTypeID);
   }
   isSpecifiedEquipType(_equipTypeId:string){
    if(_equipTypeId == null || _equipTypeId == ''){
      return false;
    } 
    return !this._dataService.isGeneralEquipmentType(_equipTypeId);
  }
  prepareSSOUIObjData(_subsoUIObj: UiTblSubSOBrkPSLevel): any {
    //_subsoUIObj.plantName = this._dataService.getPlantName(_subsoUIObj.sso.parentSORef.marketingIP.plantId);
    _subsoUIObj.customerName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.customerName);
    _subsoUIObj.projectName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.projectName);
    _subsoUIObj.salesOrderNo = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.salesOrderNo);
    _subsoUIObj.subSalesOrderNo = this.strFrmt(_subsoUIObj.sso.subOrderNoId);
    _subsoUIObj.rowHeader = _subsoUIObj.salesOrderNo + '-' + _subsoUIObj.subSalesOrderNo + '\n' + _subsoUIObj.customerName;
    //_subsoUIObj.plannedRevenueMonth = this.monthFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedRevnueMonth);
    _subsoUIObj.plannedManfMonth = this.monthFrmt(_subsoUIObj.sso.planningIP.plannedManufacturingMonth);
    _subsoUIObj.manfStrategy = this._dataService.getManufacturingStrategyName(_subsoUIObj.sso.planningIP.manufacturingStrategy);
    //_subsoUIObj.plndLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.planningIP.plannedLineLoadingDate);
    _subsoUIObj.reqLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.planningIP.requestedLineLoadingDate);
    //_subsoUIObj.actLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.productionIP.lineLoadingActualDate);
    //_subsoUIObj.customerPoValue = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.customerPoValue);
    //_subsoUIObj.marketingEngineer = this._dataService.getMarketingEngineerName(_subsoUIObj.sso.parentSORef.marketingIP.marketingEngineerId);
    //_subsoUIObj.projectManager = this._dataService.getProjectManagerName(_subsoUIObj.sso.parentSORef.marketingIP.projectManagerId);
    _subsoUIObj.projectEngineer = this._dataService.getProjectEngineerName(_subsoUIObj.sso.parentSORef.pmCommercial.projectEngineerId);
    _subsoUIObj.elecDesignEngineer = this._dataService.getElecDesignEngineerName(_subsoUIObj.sso.enggDrawIP.electricalDesignEngineerId);
    _subsoUIObj.mechDesignEngineer = this._dataService.getMechDesignEngineerName(_subsoUIObj.sso.enggDrawIP.mechanicalDesignEngineerId);
    //_subsoUIObj.salesChannelName = this._dataService.getsaleChannelName(_subsoUIObj.sso.parentSORef.marketingIP.saleChannelId);
    //_subsoUIObj.regionName = this._dataService.getRegionName(_subsoUIObj.sso.parentSORef.marketingIP.regionId);
    //_subsoUIObj.poDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.purchaseOrderDate);
    //_subsoUIObj.clearPODate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.clearPoReceiptDate);
    //_subsoUIObj.consultantName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.consultantName);
    //_subsoUIObj.warrantyMonths = this._dataService.getWarrantyMonths(_subsoUIObj.sso.parentSORef.marketingIP.warrantyMonthId);
    //_subsoUIObj.specialPoint = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.specialPoint.splPointText);
    //_subsoUIObj.specialPointFiles = _subsoUIObj.sso.parentSORef.marketingIP.specialPoint.FileArray;
    //_subsoUIObj.contractDeliveryFirm = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDateFirm);
    //_subsoUIObj.contractDeliveryWeeks = this.convNumToStr(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDateInWeek);
    //_subsoUIObj.contractDeliveryDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDate);
    //_subsoUIObj.ldApplicability = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.marketingIP.ldApplicabilityId);
    //_subsoUIObj.ldPercentage = this._dataService.getLDPercentName(_subsoUIObj.sso.parentSORef.marketingIP.ldPercent);
    //_subsoUIObj.ldCap = this._dataService.getLDCapName(_subsoUIObj.sso.parentSORef.marketingIP.ldCap + '');
    //_subsoUIObj.deliveryTerm = this._dataService.getDeliveryTermName(_subsoUIObj.sso.parentSORef.marketingIP.deliveryTerm)
    //_subsoUIObj.placeOfDelivery = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.placeOfDelivery);
    //_subsoUIObj.daysgoodsReach = this.convNumToStr(_subsoUIObj.sso.pmTechSubSalesOrder.DaysgoodsReach);
    // if(_subsoUIObj.sso.parentSORef.marketingIP.salesOrderNo == "4201849993"){
    //   console.log(_subsoUIObj.sso.pmTechSubSalesOrder.DaysgoodsReach, "days")
    // }
    //_subsoUIObj.deliveryFromAbb = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.tentativeDeliveryDate);
    //_subsoUIObj.paymentTerm = this._dataService.getPaymentTermName(_subsoUIObj.sso.parentSORef.marketingIP.paymentTermId);
    //_subsoUIObj.paymentDays = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.paymentDaysNo);
    //_subsoUIObj.FCMMatCost =this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmMatCost);
    //_subsoUIObj.JSRMatCost = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrMatCost);
    //_subsoUIObj.JSRGM = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrGm);
   
    //_subsoUIObj.JSRNM = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrNm);
    //_subsoUIObj.FCMGM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmGm);
    // _subsoUIObj.JSRGM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.pmCommercial.jsrGm);
    //_subsoUIObj.FCMNM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmNm);
    // _subsoUIObj.JSRNM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.pmCommercial.jsrNm);
    //_subsoUIObj.AdvPmtCondition = this._dataService.getAdvPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentConditionId);
    //_subsoUIObj.AdvPmt = this._dataService.getAdvPayPercentName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentId);
    //_subsoUIObj.AdvPmtMilestone = this._dataService.getAdvPayAcgABGMilestoneName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentMilestoneId);
    //_subsoUIObj.PBGPayCondition = this._dataService.getPBGPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.pbgPaymentConditionId);
    //_subsoUIObj.CPBGPayCondition = this._dataService.getCPBGPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.cpbgPaymentConditionId);

    //_subsoUIObj.SOCreationPlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationDatePlanned);
    //_subsoUIObj.SOCreationActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationDateActual);
    //_subsoUIObj.SOCreationRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationActualToken.addNotes);

    //_subsoUIObj.SOReleasePlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseDatePlanned);
    //_subsoUIObj.SOReleaseActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseDateActual);
    //_subsoUIObj.SOReleaseRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseActualToken.addNotes);

    //_subsoUIObj.OrderHandOverPlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.plannedOverHandingDate);
    //_subsoUIObj.OrderHandOverActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.actualHandingOverDate);
    //_subsoUIObj.OrderHandOverRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.actualHandingOverToken.addNotes);

    //_subsoUIObj.ABGACGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgSubmissionDetails)
    //_subsoUIObj.abgOrAcgPlndCollDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgPlndCollDate)
    //_subsoUIObj.ABGACGSubmissionPlannedDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgPlndSubDate);
    //_subsoUIObj.ABGACGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgActSubDate);
    //_subsoUIObj.ABGACGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgActCollDate);

    // _subsoUIObj.PBGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.pbgSubmissionDetails)
    // _subsoUIObj.pbgPlndSubDate= this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgPlndSubDate);
    // _subsoUIObj.pbgReqSubDate= this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgReqSubDate);
    // _subsoUIObj.PBGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgActSubDate);
    // _subsoUIObj.PBGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgActCollDate);

    // _subsoUIObj.CPBGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgSubmissionDetails)
    // _subsoUIObj.CPBGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgActSubDate);
    // _subsoUIObj.CPBGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgActCollDate);

    _subsoUIObj.variantOfProduct = this._dataService.getProductVariantName(_subsoUIObj.sso.pmTechSubSalesOrder.productVarient);
    //_subsoUIObj.noOfPanels = this._dataService.getPanelNumName(_subsoUIObj.sso.pmTechSubSalesOrder.numberOfPanels);
    //_subsoUIObj.complexityOfJobs = this._dataService.getJobComplexityName(_subsoUIObj.sso.pmTechSubSalesOrder.jobComplexity);
    //_subsoUIObj.noOfFeedertypes = this._dataService.getFeederTypeName(_subsoUIObj.sso.pmTechSubSalesOrder.FeederOrLocationTypeNo);

    //_subsoUIObj.plannedSLDSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSldSubmissionDate);
    //_subsoUIObj.initialSLDSubmissActualDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialSLDSubmissionDateActual);
    //_subsoUIObj.remarkForSLDSubmission = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialSLDSubmissionActualDateToken.addNotes);

    // _subsoUIObj.plannedGAFDrawSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate);
    // _subsoUIObj.actualGAFDrawSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialGAFDSubmissionDateActual);
    // _subsoUIObj.remarkForGAFSubmissActualDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialGAFDSubmissionActualDateToken.addNotes)

    // _subsoUIObj.plannedSchBOMSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSchematicDrawingDate);
    // _subsoUIObj.actualSchBOMSubmisDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialSchematicDBOMSubmissionDateActual);
    // _subsoUIObj.remarkSchBOMSubmissDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.addNotes);

    // _subsoUIObj.plannedBusBarSizingCalcSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSizingCalSubmissionDate);
    // _subsoUIObj.actualBusBarSizingCalcSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialGTPCTPTBBSizingCalcSubmissionDateActual);
    // _subsoUIObj.remarkBusBarSizingCalcSubmissDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialGTPCTPTBBSizingCalcSubmissionActualDateToken.addNotes);

    //_subsoUIObj.finalDrawingSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.finalDrawingSubmissionDateActual);
    //_subsoUIObj.insulationLevelKV = this._dataService.getInsulationKVName(_subsoUIObj.sso.pmTechSubSalesOrder.insulationLevel);

    // var _equipments = this.getEquipType(_subsoUIObj.equipment, _subsoUIObj.breaker);
    // _subsoUIObj.typeOfEquipment = _equipments.equipType;
    // _subsoUIObj.typeOfBreaker = _equipments.breakerType;
    // _subsoUIObj.qtyOfPanel = _equipments.qtyOfPanel;
    // _subsoUIObj.contractualValue = _equipments.contractualvalue;
    // _subsoUIObj.qtyOfVSC = _equipments.VSCQuantity;
    // _subsoUIObj.totalqtyOfBreaker = _equipments.totalqtyOfBreaker;
    // _subsoUIObj.breakerPS = _equipments.breakerPS
    // _subsoUIObj.qtyOfBreaker = _equipments.qtyOfBreaker
    // _subsoUIObj.importedEarthingSwitchApplicability = _equipments.importedSwitch;
    // _subsoUIObj.kioskApplic = this._dataService.getKioskApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.kioskApplicable);
    // _subsoUIObj.tempRiseTestApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.tempRaiseTestApplicability);
    // _subsoUIObj.impBrkApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.breakerApplicability);
    // _subsoUIObj.impVSCApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.vscApplicability);
    // _subsoUIObj.spareApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.spareApplicability);
    // _subsoUIObj.etApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.etApplicability);
    // _subsoUIObj.geRelayApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.geRelayApplicability);

    // _subsoUIObj.busbarMaterial = this._dataService.getBusbarMatrialName(_subsoUIObj.sso.pmTechSubSalesOrder.busbarMaterial);
    // _subsoUIObj.busbarSleeve = this._dataService.getBusbarSleeveName(_subsoUIObj.sso.pmTechSubSalesOrder.busbarSleeve);
    // for(var i = 0; i < _subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList.length; i++ ){
    //   _subsoUIObj.cmntOnActualSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList[i].commentRcvdOnSubActDate);
    //   _subsoUIObj.cmntOnActualComplainceDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList[i].complainceAgnstCommentActDate);
    // }
    //_subsoUIObj.plannedDrawingAprvlDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedDrawingApprovalDate);
    _subsoUIObj.actualDrawingAprvlDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualDrawingApprovalDate);
    //_subsoUIObj.remarkDrawingAprvlDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualDrawingApprovalToken.addNotes);
    //_subsoUIObj.plannedCTFinalEnggToPMDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate);
    //_subsoUIObj.actualCtFinalEnggToPMDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate);
    //_subsoUIObj.remarkCtFinalEnggToPMDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualToken.addNotes);

    // _subsoUIObj.plannedSpecialMatPricePmtoSCm = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatPriceFinalizationPlannedDate);
    // _subsoUIObj.actualSpecialMatPricePmtoSCm = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatFinalizationActualDate);
    // _subsoUIObj.remarkSpecialMatPricePmtoSCm = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatFinalizationActualDateToken.addNotes);


    // _subsoUIObj.plannedCTFinalPMtoSCMDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedCtFinalizationDate);
    // _subsoUIObj.actualCTFinalPMtoSCMDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualCtFinalizationDate);
    // _subsoUIObj.remarkCTFinalPMtoSCMDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualCtFinalizationToken.addNotes);

    // _subsoUIObj.plannedSpecialPriceGvnbyENGGtoPM = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate);
    // _subsoUIObj.actualSpecialPriceGvnbyENGGtoPM = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate);
    // _subsoUIObj.remarkSpecialPriceGvnbyENGGtoPM = this.strFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualToken.addNotes);
   

    // _subsoUIObj.plannedCTFinalfromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMPlannedDate);
    // _subsoUIObj.actualCTFinalfromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMActualDate);
    // _subsoUIObj.remarkCTFinalfromSCMDate = this.strFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMActualToken.addNotes);

    // _subsoUIObj.plannedSpecialMatPricefromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.splMatFGivenbySCMtoEnggPlannedDate);
    // _subsoUIObj.actualSpecialMatPricefromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.splMatFGivenbySCMtoEnggActualDate);
    // _subsoUIObj.remarkSpecialMatPricefromSCMDate = this.strFrmt(_subsoUIObj.sso.scmIP.splMatFGvnbySCMtoEnggActualToken.addNotes);
    
    // _subsoUIObj.plannedPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate);
    // _subsoUIObj.requestedPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.requestPackingDate);
    // _subsoUIObj.actualPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualPackingDate);
    // _subsoUIObj.remarkPackingDispatchClrDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualPackingToken.addNotes);
    // _subsoUIObj.plannedSLDApprovalDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.plannedSLDGAApprovalDate);
    // _subsoUIObj.actualSLDApprovalDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.actualSLDGAApprovalDate);
    // _subsoUIObj.remarkSLDApprovalDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.actualSLDGAApprovalToken.addNotes);
    // _subsoUIObj.plannedC40Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC40Date);
    _subsoUIObj.actualC40Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Date);
    // _subsoUIObj.remarkC40Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Token.addNotes);
    // _subsoUIObj.plannedC50Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC50Date);
    _subsoUIObj.actualC50Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Date);
    // _subsoUIObj.remarkC50Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Token.addNotes);
    // _subsoUIObj.plannedC60Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC60Date);
    _subsoUIObj.actualC60Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Date);
    //_subsoUIObj.remarkC60Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Token.addNotes);
    // _subsoUIObj.plannedLongLeadDate = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedLongLeadReleaseDate);
    // _subsoUIObj.actualLongLeadDate = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualLongLeadReleaseDate);
    // _subsoUIObj.remarkLongLeadDate = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualLongLeadReleaseToken.addNotes);
    // _subsoUIObj.plannedImpBrkrPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedPlannedDate);
    // _subsoUIObj.actualImpBrkrPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedActualDate);
    // _subsoUIObj.remarkImpBrkrPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedActualToken.addNotes);

    // _subsoUIObj.plannedImpVscPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedPlannedDate);
    // _subsoUIObj.actualImpVscPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedActualDate);
    // _subsoUIObj.remarkImpVscPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedActualToken.addNotes);
    // _subsoUIObj.plannedGERelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleasePlannedDate);
    // _subsoUIObj.actualGERelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleaseActualDate);
    // _subsoUIObj.remarkGERelayPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleaseActualToken.addNotes);
    // _subsoUIObj.plannedCTPTPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedPlannedDate);
    // _subsoUIObj.actualCTPTPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedActualDate);
    // _subsoUIObj.remarkCTPTPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedActualToken.addNotes);
    // _subsoUIObj.plannedRelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedPlannedDate);
    // _subsoUIObj.actualRelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedActualDate);
    // _subsoUIObj.remarkRelayPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedActualToken.addNotes);
    // _subsoUIObj.plannedBreakerPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleasePlannedDate);
    // _subsoUIObj.actualBreakerPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleaseActualDate);
    // _subsoUIObj.remarkBreakerPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleaseActualToken.addNotes);
    // _subsoUIObj.plannedSAPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedPlannedDate);
    // _subsoUIObj.actualSAPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedActualDate);
    // _subsoUIObj.remarkSAPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedActualToken.addNotes);
    // _subsoUIObj.plannedMeteringBoxPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleasePlannedDate);
    // _subsoUIObj.actualMeteringBoxPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleaseActualDate);
    // _subsoUIObj.remarkMeteringBoxPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleaseActualToken.addNotes);
    // _subsoUIObj.plannedPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.plannedPickListIssueToStoreDate);
    // _subsoUIObj.requestedPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.requestedPickListIssueToStoreDate);
    // _subsoUIObj.actualPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.actualPickListIssueToStoreDate);
    // _subsoUIObj.remarkPickListtoStoresDate = this.strFrmt(_subsoUIObj.sso.planningIP.actualPickListIssueToStoreToken.addNotes);

    // _subsoUIObj.plannedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerPlannedReceiptDate);
    // _subsoUIObj.requestedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerRequestedReceiptDate);
    // _subsoUIObj.supplierImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerSupplierCommittedDate);
    // _subsoUIObj.actualImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptDate);
    // _subsoUIObj.remarkImpBrkrRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptToken.addNotes);
    // _subsoUIObj.plannedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCPlannedReceiptDate);
    // _subsoUIObj.requestedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCRequestedReceiptDate);
    // _subsoUIObj.supplierImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCSupplierCommittedDate);
    // _subsoUIObj.actualImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptDate);
    // _subsoUIObj.remarkImpVSCRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptToken.addNotes);
    // _subsoUIObj.plannedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayPlannedReceiptDate);
    // _subsoUIObj.requestedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayRequestedReceiptDate);
    // _subsoUIObj.supplierGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelaySupplierCommittedDate);
    // _subsoUIObj.actualGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptDate);
    // _subsoUIObj.remarkGERelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptToken.addNotes);
    // _subsoUIObj.plannedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTPlannedReceiptDate);
    // _subsoUIObj.requestedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTRequestedReceiptDate);
    // _subsoUIObj.supplierCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTSupplierCommittedDate);
    // _subsoUIObj.actualCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptDate);
    // _subsoUIObj.remarkCTPTRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptToken.addNotes);
    // _subsoUIObj.plannedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayPlannedReceiptDate);
    // _subsoUIObj.requestedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayRequestedReceiptDate);
    // _subsoUIObj.supplierRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relaySupplierCommittedDate);
    // _subsoUIObj.actualRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptDate);
    // _subsoUIObj.remarkRelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptToken.addNotes);
    // _subsoUIObj.plannedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerPlannedReceiptDate);
    // _subsoUIObj.requestedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerRequestedReceiptDate);
    // _subsoUIObj.supplierBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerSupplierCommittedDate);
    // _subsoUIObj.actualBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptDate);
    // _subsoUIObj.remarkBreakerRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptToken.addNotes);
    // _subsoUIObj.plannedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperPlannedReceiptDate);
    // _subsoUIObj.requestedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperRequestedReceiptDate);
    // _subsoUIObj.supplierJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperSupplierCommittedDate);
    // _subsoUIObj.actualJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptDate);
    // _subsoUIObj.remarkJumperRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptToken.addNotes);
    // _subsoUIObj.plannedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxPlannedReceiptDate);
    // _subsoUIObj.requestedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxRequestedReceiptDate);
    // _subsoUIObj.supplierMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxSupplierCommittedDate);
    // _subsoUIObj.actualMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptDate);
    // _subsoUIObj.remarkMeterBoxRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptToken.addNotes);
    // _subsoUIObj.plannedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saPlannedReceiptDate);
    // _subsoUIObj.requestedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saRequestedReceiptDate);
    // _subsoUIObj.supplierSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saSupplierCommittedDate);
    // _subsoUIObj.actualSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptDate);
    // _subsoUIObj.remarkSARcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptToken.addNotes);
    // _subsoUIObj.plannedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationPlannedReceiptDate);
    // _subsoUIObj.requestedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationRequestedReceiptDate);
    // _subsoUIObj.supplierBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationSupplierCommittedDate);
    // _subsoUIObj.actualBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptDate);
    // _subsoUIObj.remarkBoughtoutFabricationRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptToken.addNotes);

    // _subsoUIObj.plannedInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationPlannedReceiptDate);
    // _subsoUIObj.requestedInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationRequestedReceiptDate);
    // _subsoUIObj.supplierInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationSupplierCommittedDate);
    // _subsoUIObj.actualInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationActualReceiptDate);
    // _subsoUIObj.remarkInHouseFabricationRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationActualReceiptToken.addNotes);

    // _subsoUIObj.plannedMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLinePlannedDate);
    // _subsoUIObj.requestedMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineRequestLineLodingDate);
    // _subsoUIObj.actualMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineActualDate);
    // _subsoUIObj.remarkMatIssuetoLineDate = this.strFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineActualToken.addNotes);
    // _subsoUIObj.plannedLooseMatIssueDate = this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchPlannedDate);
    // _subsoUIObj.looseMaterialIssueToDispatchRequestDate= this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchRequestDate);
    // _subsoUIObj.actualLooseMatIssueDate = this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchActualDate);
    // _subsoUIObj.remarkLooseMatIssueDate = this.strFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchActualToken.addNotes);
    // _subsoUIObj.plannedMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerPlannedDate);
    // _subsoUIObj.requestedMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerRequestedDate);
    // _subsoUIObj.actualMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualDate);
    // _subsoUIObj.remarkMechStickerDate = this.strFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualToken.addNotes);
    // _subsoUIObj.plannedMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingPlannedDate);
    // _subsoUIObj.requestedMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingRequestedDate);
    // _subsoUIObj.actualMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingActualDate);
    // _subsoUIObj.remarkMechElecTestDate = this.strFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingActualToken.addNotes);
    // _subsoUIObj.plannedFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatPlannedDate);
    // _subsoUIObj.requestedFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatRequestedDate);
    // _subsoUIObj.actualFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatActualDate);
    // _subsoUIObj.remarkFATDate = this.strFrmt(_subsoUIObj.sso.qualityIP.fatActualToken.addNotes);
    // _subsoUIObj.plannedGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerPlannedDate);
    // _subsoUIObj.requestedGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerRequestedDate);
    // _subsoUIObj.actualGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerActualDate);
    // _subsoUIObj.remarkGreenStickerDate = this.strFrmt(_subsoUIObj.sso.qualityIP.greenStickerActualToken.addNotes);
    // _subsoUIObj.plannedDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.dispatchFromPlantPlannedDate);
    // _subsoUIObj.requestedDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.dispatchFromPlantRequestDate);


    // var _pDeliveries = this.getPartialDispatches(_subsoUIObj.sso);
    // _subsoUIObj.actualDispatchDate = _pDeliveries.dispatchDate;
    // _subsoUIObj.remarkDispatchDate = _pDeliveries.notes;
    // _subsoUIObj.partialDispatchQty = _pDeliveries.dispatchQty;

    // _subsoUIObj.actualEarthlingTruckDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.earthlingTruckActualDispatchDate);
    // _subsoUIObj.actualSparesDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.sparesActualDispatchDate);

    //_subsoUIObj.cellRowSpan

  }
  getPartialDispatches(sso: SubSalesOrder): any {
    var retVal: any = { "dispatchQty": "", "dispatchDate": "", "notes": "" };

    sso.logisticIP.partialDeliveries.forEach((_pDelivery: PartialDelivery) => {
      var _divider = '\n';
      retVal.dispatchQty += (retVal.dispatchQty != '' ? _divider : '') + this.convNumToStr(_pDelivery.partialDispatchQty);
      retVal.dispatchDate += (retVal.dispatchDate != '' ? _divider : '') + this.dtFrmt(_pDelivery.dispatchFromPlantActualToken.actualDate);
      retVal.notes += (retVal.notes != '' ? _divider : '') + this.strFrmt(_pDelivery.dispatchFromPlantActualToken.addNotes);
    });
    return retVal;
  }
  getEquipType(_equip: Equipment, brk: BreakerPS): any {
    var retVal: any = { "equipType": "", "breakerType": "", "qtyOfPanel": "", "contractualvalue": "", "VSCQuantity ": "", "qtyOfBreaker": "", "breakerPS": "", "importedSwitch": "" };

    retVal.equipType = this._dataService.getEquipmentTypeName(_equip.equipmentType);
    retVal.breakerType = this._dataService.getBreakerTypeName(_equip.breakerType);
    retVal.qtyOfPanel = this.frmtNumStr(_equip.panelQuantity);
    retVal.contractualvalue = this.frmtNumStr(_equip.contractualValue);
    retVal.VSCQuantity = this.frmtNumStr(_equip.vscQuantity);
    retVal.totalqtyOfBreaker =  _equip.totalBreakerQuantity
    if(brk){
      retVal.breakerPS = this.strFrmt(brk.breakerPs);
      retVal.qtyOfBreaker = brk.breakerQuantity
    }
    retVal.importedSwitch = this._dataService.getApplicabilityOptionName(_equip.earthSwithApplicability);


    return retVal;
  }
  strFrmt(_str: string) {
    if (_str) return _str;
    return '';
  }
  frmtNumStr(_numstr: string) {
    if (_numstr) return _numstr;
    return '';
  }
  convNumToStr(_num: number) {
    if (_num) return _num + '';
    return '';
  }
  dtFrmt(_dt: Date): string {
    return GenService.getDateFormatStr(_dt, 'd-mmm-YY')
  }
  monthFrmt(_dt: Date): string {
    return GenService.getDateFormatStr(_dt, 'mmm-YY')
  }

  reloadData(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.loadData();  
    }, 2);
  }
  getColumnName(_index: number): string {
    return GenService.getExcelColumnName(_index);
  }
  tableScrolledLeft: boolean = false;
  onScroll(_scrlEvnt: any) {
    // if (_scrlEvnt && _scrlEvnt.srcElement) {
    //   let _scrollLeft: number = _scrlEvnt.srcElement.scrollLeft;
    //   let _newSetting = (_scrollLeft > 150) ? true : false;
    //   if(this.tableScrolledLeft != _newSetting){
    //     this.tableScrolledLeft = _newSetting
    //   }
    // }
  }
  downloadExcel() {
    this._dataService.downloadFile('mast');
  }
  downloadExcelmark() {
    this._dataService.downloadFile('mrktg');
  }
  downloadExcelbrkrp() {
    this._dataService.downloadFile('brkrp');
  }
  downloadExceldspch() {
    this._dataService.downloadFile('dspch');
  }

  // _rowCounter:number = 0;
  // getRowHeader(_sno: number, _rowHeader: string) {
  //   if (this.tableScrolledLeft == true) {
  //     return _rowHeader;
  //   }
  //   if(_sno == 0) this._rowCounter = 0;
  //   return (++this._rowCounter) + '';
  // }

  filterRows(): void {
    let _filteredSSO: Array<UiTblSubSOBrkPSLevel> = this._filterPipe.transform(this._breakerPSUIObjList, this.search);

    let _tmpFilteredCustList:Array<string> = [];
    let _tmpFilteredProjNameList:Array<string> = [];
    let _tmpFilteredSONumList:Array<string> = [];
    _filteredSSO.forEach((_tmpObj:UiTblSubSOBrkPSLevel) => {
      if(_tmpObj.customerName && _tmpFilteredCustList.indexOf(_tmpObj.customerName) < 0){
        _tmpFilteredCustList.push(_tmpObj.customerName);
      }
      
      if(_tmpObj.projectName && _tmpFilteredProjNameList.indexOf(_tmpObj.projectName) < 0){
        _tmpFilteredProjNameList.push(_tmpObj.projectName);
      }

      if(_tmpObj.salesOrderNo && _tmpFilteredSONumList.indexOf(_tmpObj.salesOrderNo) < 0){
        _tmpFilteredSONumList.push(_tmpObj.salesOrderNo);
      }

      
    });
    _tmpFilteredCustList.sort();
    _tmpFilteredProjNameList.sort();
    _tmpFilteredSONumList.sort();


    this.filteredCustList.length = 0;
    _tmpFilteredCustList.forEach((_custName:string) => {
      this.filteredCustList.push(new columnFilter(_custName,_custName,true));
    });

    this.filteredProjectNameList.length = 0;
    _tmpFilteredProjNameList.forEach((_projectName:string) => {
      this.filteredProjectNameList.push(new columnFilter(_projectName,_projectName,true));
    });

    this.filteredSONumList.length = 0;
    _tmpFilteredSONumList.forEach((_SOOrderNum:string) => {
      this.filteredSONumList.push(new columnFilter(_SOOrderNum,_SOOrderNum,true));
    });

    // let _tmpRowSpanArr:any = {};

    // let _tmpSubSOIndex:number = 0;
    // _filteredSSO.forEach((_subSOBrkPS:UiTblSubSOBrkPSLevel) => {

    //   let _tmpHeadCellIndex:number  = 0;
    //   this.filteredHeadRows.forEach((headCell:TblHeadCellDef) => {
    //       if(_tmpRowSpanArr[_tmpSubSOIndex] == null){
    //         _tmpRowSpanArr[_tmpSubSOIndex] = {};
    //       }
    //       _tmpRowSpanArr[_tmpSubSOIndex][_tmpHeadCellIndex] = this.getCellRowSpan(_subSOBrkPS, _tmpHeadCellIndex);

    //       _tmpHeadCellIndex++;
    //   });

    //   _tmpSubSOIndex++;
    // });
    // this._rowSpanArr = _tmpRowSpanArr;
    this._filteredSubSoUIObjList = _filteredSSO;
    this.cd.markForCheck();
  }

  getDownloadLink(_fObj: FileElement) {
    return '/downloadfile?actname=' + encodeURIComponent(_fObj.filename) + '&fref=' + _fObj.fileref;
  }

  public getSpecialPointFiles(subSOTbl: UiTblSubSOBrkPSLevel) {
    return subSOTbl.specialPointFiles;
  }

  screenToggle() {
    this.isFullScreenTbl = !this.isFullScreenTbl;
  }

  getRevMonthLabel():string{
    if(this.isRevMonthFilterSelected == true){
      return "Revenue Month : ";
    }
    else{
      return "Enable Revenue Month Filter";
    }
  }

  getManfMonthLabel():string{
    if(this.isManfMonthFilterSelected == true){
      return "Manufacturing Month : ";
    }
    else{
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfStrategyLabel():string{
    if(this.isManfStrategyFilterSelected == true){
      return "Manufacturing Strategy : ";
    }
    else{
      return "Enable Manufacturing Strategy Filter";
    }
  }

  getUserFilterLabel():string{
    if(this.isUserSelectionFilterSelected == true){
      return "User Selection : ";
    }
    else{
      return "Enable User Selection Filter";
    }
  }

  getManfFromMonthName():string{
    if(this.manfMonthFilter){
      return this.manfMonthFilter.fromMonthName;
    }
    return '';
  }
  getManfToMonthName():string{
    if(this.manfMonthFilter){
      return this.manfMonthFilter.toMonthName;
    }
    return '';
  }

  getRevFromMonthName():string{
    if(this.revMonthFilter){
      return this.revMonthFilter.fromMonthName;
    }
    return '';
  }

  getRevToMonthName():string{
    if(this.revMonthFilter){
      return this.revMonthFilter.toMonthName;
    }
    return '';
  }

  loadSettingsFromCookies(){
    let _tmpSearch:string = this._dataService.getCookie('s-search');
    if(_tmpSearch){
      this.search = _tmpSearch;
    }
    let _tmpRevMonthSel:string = this._dataService.getCookie('s-revmonth-sel');
    if(_tmpRevMonthSel){
      this.isRevMonthFilterSelected = (_tmpRevMonthSel == "1");

      let _tmpRevMonthVal:string = this._dataService.getCookie('s-revmonth-val');
      if(_tmpRevMonthVal){
        this.revMonthFilter = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
      }
    }
    let _tmpManfMonthSel:string = this._dataService.getCookie('s-manfmonth-sel');
    if(_tmpManfMonthSel){
      this.isManfMonthFilterSelected = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal:string = this._dataService.getCookie('s-manfmonth-val');
      if(_tmpManfMonthVal){
        this.manfMonthFilter = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }
    let _tmpManfStraSel:string = this._dataService.getCookie('s-manfstra-sel');
    if(_tmpManfStraSel){
      this.isManfStrategyFilterSelected = (_tmpManfStraSel == "1");

      let _tmpManfStraVal:string = this._dataService.getCookie('s-manfstra-val');
      if(_tmpManfStraVal){
        this.manfStrategyIndex = parseInt(_tmpManfStraVal , 10);
      }
    }
    let _tmpUserDeptSel:string = this._dataService.getCookie('s-userdept-sel');
    if(_tmpUserDeptSel){
      this.isUserSelectionFilterSelected = (_tmpUserDeptSel == "1");

      let _tmpUserDeptVal:string = this._dataService.getCookie('s-userdept-val');
      if(_tmpUserDeptVal){
        this.extractUserDeptSelToken(_tmpUserDeptVal, true);
      }
    }

    let _currDate:Date = new Date();
    if(this.revMonthFilter == null){
      this.revMonthFilter = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
      _currDate.getMonth()+1, _currDate.getFullYear());
    }
    if(this.manfMonthFilter == null){
      this.manfMonthFilter = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
      _currDate.getMonth()+1, _currDate.getFullYear());
    }
  }

  extractUserDeptSelToken(_tmpToken:string, _updateSource:boolean):boolean{
    let _tokens:Array<string> = _tmpToken.split(',');
     if(_tokens.length == 3){
       this.userSelectionType = parseInt(_tokens[0], 10);
       if(this.userSelectionType != userFilterOption.All){
         this.userDeptIdSelected = _tokens[1];
       }
       if(_updateSource == true){
         this.userDeptSelToken = _tmpToken;
       }
       return true;
     }
     return false;
  }

  getManfStrategyName():string{
    if(this.manfStrategyIndex >= 0 && this.manfStrategyIndex < this._dataService.manufacturtingStrategy.length){
      return this._dataService.manufacturtingStrategy[this.manfStrategyIndex].manufacturtingStrategyName;
    }
    return '';
  }

  userSelected(){
    if(this.extractUserDeptSelToken(this.userDeptSelToken, false)){
      this.filterRows();
    }

  }

  ProjectNameFilter(){
    console.log(this.filteredProjectNameList)
    this._filteredSubSoUIObjList = [];
    let _filteredSSO: Array<UiTblSubSOBrkPSLevel> = this._filterPipe.transform(this._breakerPSUIObjList, this.search);
    for(var i = 0; i < this.filteredProjectNameList.length ; i++){
      var _filteredProjectNameList = this.filteredProjectNameList[i];
      if(_filteredProjectNameList.isSelected == true){
       _filteredSSO.forEach((_projectName:UiTblSubSOBrkPSLevel)=>{
          if(_projectName.projectName == _filteredProjectNameList.dispName){
              this._filteredSubSoUIObjList.push(_projectName)
          }
       })
      }
    }
  }

  SalesOrderNumberFilter(){
    console.log(this.filteredSONumList)
    this._filteredSubSoUIObjList = [];
    let _filteredSSO: Array<UiTblSubSOBrkPSLevel> = this._filterPipe.transform(this._breakerPSUIObjList, this.search);
    for(var i = 0; i < this.filteredSONumList.length ; i++){
      var _filteredSONumList = this.filteredSONumList[i];
      if(_filteredSONumList.isSelected == true){
       _filteredSSO.forEach((_projectName:UiTblSubSOBrkPSLevel)=>{
          if(_projectName.salesOrderNo == _filteredSONumList.dispName){
              this._filteredSubSoUIObjList.push(_projectName)
          }
       })
      }
    }
  }
}
